import { useState, useCallback } from "react";
import style from "../style.module.css";
import FolderWideIcon from "views/components/icons/FolderWideIcon";
import EllipsisIcon from "views/components/icons/EllipsisIcon";
import TrashIcon from "views/components/icons/TrashIcon";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore JS component lacks TS types
import ScrollingOverflowText from "views/components/ScrollingOverflowText/ScrollingOverflowText";
import MobileUploadActionSheet from "views/containers/DesignsPageContainer/Workspace/mobile/MobileUploadActionSheet";
import PopoutItemMenu from "views/components/popout/PopoutItemMenu/PopoutItemMenu";
import confirmDeleteFolder from "../confirmDeleteFolder";

/* eslint-disable @typescript-eslint/no-explicit-any */

interface MobileFolderRowProps {
  folder: {
    id: string;
    name: string;
  };
  changePage: (path: string) => void;
  imageOriginPath: string;
  onDeleteImageFolder: (args: { folderId: string }) => void;
  onUpdateImageFolder: (args: { folder: { id: string; name: string } }) => void;
}

const MobileFolderRow = ({
  folder,
  changePage,
  imageOriginPath,
  onDeleteImageFolder,
  onUpdateImageFolder
}: MobileFolderRowProps) => {
  const [isActionSheetOpen, setIsActionSheetOpen] = useState(false);

  const handleOpenActionSheet = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setIsActionSheetOpen(true);
  }, []);

  const handleCloseActionSheet = useCallback(() => {
    setIsActionSheetOpen(false);
  }, []);

  const handleFolderClick = useCallback(() => {
    changePage(`${imageOriginPath}?folderId=${folder.id}`);
  }, [changePage, imageOriginPath, folder.id]);

  const actions = [
    {
      name: "Delete",
      Icon: ((props: any) => <TrashIcon version="2" {...props} />) as any,
      onClick: confirmDeleteFolder({
        onOk: () => {
          handleCloseActionSheet();
          onDeleteImageFolder({ folderId: folder.id });
        },
        onCancel: handleCloseActionSheet
      })
    }
  ];

  return (
    <>
      <div className={style.mobileFolderRow} onClick={handleFolderClick}>
        <div className={style.mobileFolderTile}>
          {/* @ts-expect-error JS icon component lacks proper TS types */}
          <FolderWideIcon
            strokeWidth="1.5"
            color="#9a9b9d"
            width="22px"
            height="18px"
          />
        </div>
        <ScrollingOverflowText
          className={style.mobileFolderName}
          title={folder.name}
        >
          {folder.name}
        </ScrollingOverflowText>
        <button
          className={style.mobileActionButton}
          onClick={handleOpenActionSheet}
          type="button"
          aria-label="Folder actions"
        >
          {/* @ts-expect-error JS icon component lacks proper TS types */}
          <EllipsisIcon color="#999c9e" size="24px" />
        </button>
      </div>
      <MobileUploadActionSheet
        isOpen={isActionSheetOpen}
        onClose={handleCloseActionSheet}
      >
        {/* @ts-expect-error JS component has loosely typed props */}
        <PopoutItemMenu
          actions={actions}
          onClose={handleCloseActionSheet}
          itemName={folder.name}
          onRename={(newName: string) => {
            onUpdateImageFolder({
              folder: { ...folder, name: newName }
            });
            handleCloseActionSheet();
          }}
        />
      </MobileUploadActionSheet>
    </>
  );
};

export default MobileFolderRow;
